import {
  LuArrowUpDown, LuBadgeCheck, LuBot, LuChartColumn, LuChartLine, LuCirclePlus, LuDownload, LuFileText,
  LuLayers, LuListChecks, LuMessageCircle, LuPlug, LuSearch, LuSlidersHorizontal, LuTable,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
// The sub-tabs switch the URL (/inbox/<tab>), so they are route tours; the
// longer scope wins over the landing tour's `/inbox`.
const tours = [
  tour('inbox', '/inbox', 'inbox', [
    ['tabs', 'inbox.tabs', LuLayers],
    ['filters', 'inbox.filters', LuSlidersHorizontal, opt],
    ['status', 'inbox.status', LuListChecks, opt],
    ['chat', 'inbox.chat', LuMessageCircle, { placement: 'left', padding: 0, ...opt }],
  ]),
  tour('inbox_dashboard', '/inbox/dashboard', 'inbox', [
    ['kpis', 'inbox_dashboard.kpis', LuChartColumn],
    ['charts', 'inbox_dashboard.charts', LuChartLine, { placement: 'top', ...opt }],
    ['report', 'inbox_dashboard.report', LuDownload, opt],
  ]),
  tour('inbox_templates', '/inbox/templates', 'inbox', [
    ['intro', 'inbox_templates.intro', LuFileText],
    ['create', 'inbox_templates.create', LuCirclePlus, opt],
    ['status', 'inbox_templates.status', LuBadgeCheck, opt],
    ['list', 'inbox_templates.list', LuTable, { placement: 'top', ...opt }],
  ]),
  tour('inbox_history', '/inbox/history', 'inbox', [
    ['list', 'inbox_history.list', LuTable, { placement: 'top' }],
    ['search', 'inbox_history.search', LuSearch, opt],
    ['sort', 'inbox_history.sort', LuArrowUpDown, opt],
  ]),
  tour('inbox_chatbots', '/inbox/chatbots', 'inbox', [
    ['list', 'inbox_chatbots.list', LuBot, { placement: 'top' }],
    ['create', 'inbox_chatbots.create', LuCirclePlus, opt],
    ['filters', 'inbox_chatbots.filters', LuSlidersHorizontal, opt],
  ]),
  tour('inbox_channels', '/inbox/channels', 'inbox', [
    ['list', 'inbox_channels.list', LuPlug, { placement: 'top' }],
    ['add', 'inbox_channels.add', LuCirclePlus, opt],
  ]),
];

export default tours;
